/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basicinformation1Inputs */

const en_basicinformation1 = /** @type {(inputs: Basicinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Information`)
};

const de_basicinformation1 = /** @type {(inputs: Basicinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlegende Informationen`)
};

/**
* | output |
* | --- |
* | "Basic Information" |
*
* @param {Basicinformation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const basicinformation1 = /** @type {((inputs?: Basicinformation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basicinformation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_basicinformation1(inputs)
	return de_basicinformation1(inputs)
});
export { basicinformation1 as "basicInformation" }